"use client"

import { Plus } from "geist-icons";
import type React from "react";

interface CircleGridProps {
  className?: string;
}

export const CircleGrid: React.FC<CircleGridProps> = ({ className }) => {
  return (
    <div
      className={`w-full border-b border-r border-l border-[#EAEAEA] dark:border-[#1E1E1E] ${className}`}
    >
      {/* Main grid container - single row with responsive columns */}
      <div className="relative flex w-full h-full">
        {/* Main grid cells - responsive number based on screen size */}
        <div className="w-full grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 h-full">
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className={`border-b border-l border-r aspect-square border-[#EAEAEA] dark:border-[#1E1E1E] relative ${
                index >= 3 ? "hidden md:block" : ""
              } ${index === 4 ? "hidden sm:block" : ""}`}
            >

              {/* Circle inside square */}
              <div className="absolute inset-0 m-auto w-[90%] h-[90%] border border-[#EAEAEA] dark:border-[#1E1E1E] rounded-full z-20 ">
                {/* Symmetrical pattern - Cross */}
                <div className="absolute left-1/2 top-0 w-[1px] h-full bg-[#EAEAEA] dark:bg-[#1E1E1E] z-50"></div>
                <div className="absolute left-0 top-1/2 w-full h-[1px] bg-[#EAEAEA] dark:bg-[#1E1E1E] z-50"></div>

                {/* Inner circle for complexity */}
                <div className="absolute left-[25%] top-[25%] right-[25%] bottom-[25%] border border-[#EAEAEA] dark:border-[#1E1E1E] rounded-full z-20">
                  {/* Inner cross pattern */}
                  <div className="absolute left-1/2 top-0 w-[1px] h-full borrder bg-[#EAEAEA] dark:bg-[#1E1E1E] z-20"></div>
                  <div className="absolute left-0 top-1/2 w-full h-[1px] bg-[#EAEAEA] dark:bg-[#1E1E1E] z-20"></div>
                </div>
                {/* Diagonal lines - symmetrical X pattern */}
                <div className="absolute left-0 top-0 w-full h-full overflow-hidden">
                  <div className="absolute left-1/2 top-0 w-[1px] h-full bg-[#EAEAEA] dark:bg-[#1E1E1E] origin-top rotate-45"></div>
                  <div className="absolute left-1/2 top-0 w-[1px] h-full bg-[#EAEAEA] dark:bg-[#1E1E1E] origin-top -rotate-45"></div>
                </div>
                <div className="absolute right-0 bottom-0 w-full h-full overflow-hidden">
                  <div className="absolute right-1/2 bottom-0 w-[1px] h-full bg-[#EAEAEA] dark:bg-[#1E1E1E] origin-bottom rotate-45"></div>
                  <div className="absolute right-1/2 bottom-0 w-[1px] h-full bg-[#EAEAEA] dark:bg-[#1E1E1E] origin-bottom -rotate-45"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Bottom left plus sign */}
        <div className="absolute z-[30] -bottom-[10px] -left-[10px] flex items-center justify-center">
          <Plus className="text-[#A8A8A8] dark:text-[#878787] scale-100 md:scale-130" />
        </div>
      </div>
    </div>
  );
};
